<template>
  <div>
    <h2 class="donate-card__thanks-heading">Thank you for your donation.</h2>
    <div class="donate-card__content pb-6"> {{ content }}</div>
    <div class="donate-card__summary">
      <div class="flex"><span>Name:</span> {{ donation.customer_data.first_name }} {{ donation.customer_data.last_name }}</div>
      <div class="flex">
        <span>Address:</span>
        <div>
          <p>{{ donation.customer_data.billing_address.address_line1 }}</p>
          <p v-if="donation.customer_data.billing_address.address_line2">{{ donation.customer_data.billing_addressaddress_line2 }}</p>
          <p>{{ donation.customer_data.billing_address.city }}, {{ donation.customer_data.billing_address.region }} {{ donation.customer_data.billing_address.postal_code }} {{ donation.customer_data.billing_address.country }}</p>
        </div>
      </div>
      <div class="flex"><span>Email Address:</span> {{ donation.customer_data.email }}</div>
      <div class="flex"><span>Appeal:</span> {{ donation.appeal.name }}</div>
      <div class="flex"><span>Donation Date:</span> {{ today }}</div>
      <div class="flex"><span>Gift Amount:</span> ${{ donation.amount }}</div>
      <div class="flex"><span>Order Number:</span> {{ donation.order_number }}</div>
    </div>
    <a
      :href="referrer"
      class="donate-card__button donate-card__submit"
    >
      Continue browsing
    </a>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { parse, format } from 'date-fns'

export default {
  name: 'DonateCardSuccess',

  props: {
    content: {
      type: String,
      default: ''
    },
    donation: {
      type: Object,
      default: () => ({
        id: '',
        amount: 0,
        appeal: {}
      })
    }
  },

  computed: {
    ...mapState(['referrer']),

    today() {
      return format(parse(new Date()), 'YYYY/MM/DD')
    }
  }
}
</script>
<style lang="postcss" scoped>
span {
  width: 110px;
}
</style>
